'use strict';

var symbols = require('./constants').symbols;

module.exports = function getCurrencySymbol(currencyENUM) {
    return symbols[currencyENUM];
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/~/dibs-currency-helpers/getCurrencySymbol.js
// module id = 2644
// module chunks = 62